var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_check"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 5444",
    x: 2,
    y: 14.1213,
    width: 3,
    height: 11.8263,
    rx: 1.5,
    transform: "rotate(-45 2 14.1213)",
    fill: "#FE8C00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 5445",
    x: 23.8711,
    y: 6,
    width: 3,
    height: 21.0296,
    rx: 1.5,
    transform: "rotate(45 23.8711 6)",
    fill: "#FE8C00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheck);
export default __webpack_public_path__ + "static/media/icon-check.5a0b52bfae441d1e7df26a3591f6a0f2.svg";
export { ForwardRef as ReactComponent };